import React, { createContext, useState } from "react";

const SelectedLabContext = createContext({
  selectedLab: null,
  setSelectedLab: () => {},
});

function SelectedLabProvider({ children }) {
  const [selectedLab, setSelectedLab] = useState(null);

  return (
    <SelectedLabContext.Provider value={{ selectedLab, setSelectedLab }}>
      {children}
    </SelectedLabContext.Provider>
  );
}

export { SelectedLabContext, SelectedLabProvider };
